// Simple helper to show PrimeReact Toast messages safely
// Usage: showToast(toastRef, 'success', 'Saved', 'Your changes were saved', 3000)
export const showToast = (toastRef, severity, summary, detail, life = 3000) => {
    if (toastRef && toastRef.current) {
        toastRef.current.show({ severity, summary, detail, life });
    }
};

export default showToast;


